import config from './config';

export default function debugLogging(message, ctx = null) {
    if (config.env !== 'production') {
        console.log(`@AssetsService: ${message}`, ctx);
    }
}
